import { BrowserRouter, Routes, Route } from "react-router-dom";

import {
  Home,
  Login,
  ForgotPassword,
  Overview,
  Instructors,
  Candidates,
  Lessons,
  Vehicles,
  Lectures,
  VideoLectures,
  Reports,
  Payments,
  Notifications,
  Profile,
} from "./pages";
import SetupAdmin from "./pages/SetupAdmin";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        {/* Public Routes - Redirect to dashboard if already logged in */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route path="/setup-admin" element={<SetupAdmin />} />

        {/* Protected Dashboard Routes - Require Authentication */}
        <Route
          path="/dashboard/overview"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Overview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/instructors"
          element={
            <ProtectedRoute allowedRoles={["admin", "candidate"]}>
              <Instructors />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/candidates"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor"]}>
              <Candidates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/lessons"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor", "candidate"]}>
              <Lessons />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/vehicles"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Vehicles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/lectures"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor", "candidate"]}>
              <Lectures />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/video-lectures"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor", "candidate"]}>
              <VideoLectures />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/reports"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor"]}>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/payments"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Payments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/notifications"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor", "candidate"]}>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/profile"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor", "candidate"]}>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
